<template>
    <v-container>
        <v-row>
            <v-col cols="14" offset="1" sm="8" offset-sm="4">
                <h2 class="add-member__title">Pozvat dalšího hráče</h2>
                <v-autocomplete
                    v-model="selectedUser"
                    :items="suggestedUsers"
                    :loading="suggesting"
                    :search-input.sync="searchUser"
                    item-text="nickname"
                    item-value="id"
                    return-object
                    clearable
                    hide-details
                    append-icon="mdi-magnify"
                    label="Přezdívka hráče"
                >
                </v-autocomplete>
                <v-btn
                    class="primary"
                    :loading="inviting"
                    :disabled="inviting || !canInvite"
                    @click.stop="invite"
                >
                    Odeslat pozvánku
                </v-btn>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { LISTING_USERS_REQUEST } from '../../store/actions/user';
    import { USER_INVITE_REQUEST } from '../../store/actions/team';

    export default {
        name: 'AddMember',
        data () {
            return {
                selectedUser: null,
                suggestedUsers: [],
                suggesting: false,
                searchUser: '',
                lastSearchUser: '',
                inviting: false,
            };
        },
        computed: {
            ...mapGetters('team', [
                'canAddMember',
            ]),
            canInvite () {
                return this.canAddMember === true && this.selectedUser !== null;
            },
        },
        watch: {
            searchUser (user) {
                setTimeout(async () => {
                    if (user === null || user === undefined || user.length < 3 || user === this.lastSearchUser) {
                        return;
                    }

                    try {
                        this.suggesting = true;
                        this.suggestedUsers = await this.$store.dispatch('user/' + LISTING_USERS_REQUEST, {
                            nickname: user,
                            team: '0',
                        });
                    } catch (e) {
                    } finally {
                        this.suggesting = false;
                    }

                }, 200);
            },
        },
        methods: {
            async invite () {
                if (this.canInvite === false) {
                    return;
                }

                try {
                    this.inviting = true;
                    await this.$store.dispatch('team/' + USER_INVITE_REQUEST, {
                        userId: this.selectedUser.id,
                    });
                    this.$toast.success('Pozvánka byla odeslána.');
                    this.selectedUser = null;
                } catch (e) {
                    const message = e.response.data.message || 'Došlo k chybě. Zkuste to později.';
                    this.$toast.error(message);
                } finally {
                    this.inviting = false;
                }
            },
        },
    }
</script>
